import { string, object, date, number } from "yup";

export const InventaireSchema = object({

  depots_id: string().required("depots obligatoire!!"),
});
 